import Vue from 'vue';
import VueRouter from 'vue-router';

import router from './init-router';
import initModules from './init-modules';

Vue.use(VueRouter);

initModules(router);

export default router;
